'use client';

import dynamic from 'next/dynamic';
import { LottieRef } from 'lottie-react';
import { useEffect, useRef, useState } from 'react';
import animationData from 'app/assets/lottie/stretch.json';

const DynamicLottie = dynamic(() => import('lottie-react'), { ssr: false });

export default function StretchAnimation({
  play = false,
  loop = false,
  onComplete = () => {},
  color = 'white'
}: {
  play?: boolean;
  loop?: boolean;
  onComplete?: () => void;
  color?: 'white' | 'brown';
}) {
  const lottieRef: LottieRef = useRef(null);
  const [isLottieReady, setIsLottieReady] = useState(false);
  const onCompleteCallback = useRef(onComplete);

  const animate = () => {
    lottieRef?.current?.setDirection(1);
    lottieRef?.current?.play();
  };

  useEffect(() => {
    if (!isLottieReady || !play) return;

    animate();
  }, [play, isLottieReady]);

  return (
    <DynamicLottie
      className="absolute top-0 left-0 w-full h-full"
      lottieRef={lottieRef}
      animationData={animationData}
      loop={loop}
      autoPlay={false}
      start={0}
      rendererSettings={{ className: `stretch-animation-${color}` }}
      onDOMLoaded={e => {
        lottieRef.current?.stop();
        setIsLottieReady(true);
      }}
      onComplete={() => {
        onCompleteCallback.current();
      }}
    />
  );
}
